import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createSupportTicket,
  updateSupportTicket,
  deleteSupportTicket,
} from './request';
import { SUPPORT_TICKETS_QUERY_KEY } from '@/api';
import type {
  CreateSupportTicketPayload,
  UpdateSupportTicketPayload,
} from '@/types';

export const useCreateSupportTicket = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateSupportTicketPayload) =>
      createSupportTicket(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY],
      });
      onSuccess?.();
    },
  });
};

export const useUpdateSupportTicket = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      uuid,
      payload,
    }: {
      uuid: number | string;
      payload: UpdateSupportTicketPayload;
    }) => updateSupportTicket({ uuid, payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY],
      });
      onSuccess?.();
    },
  });
};

export const useDeleteSupportTicket = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (uuid: number | string) => deleteSupportTicket(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SUPPORT_TICKETS_QUERY_KEY],
      });
      onSuccess?.();
    },
  });
};
